import React from 'react'
import './figurecards.scss'
import { Row, Col } from 'react-bootstrap';
const FigureCards = ({ data , heading,para }) => {
    return (
        <div className='figure-main'>
            <div className='heading'>
               <h3>{heading}</h3>
            </div>
            <div className='text'>
            <p>{para}</p>
            </div>
            <Row>
                {data.map((item) => (
                    <Col sm={12} md={4} lg={4} xl={4}>
                        <div key={item.id} className="figure-card-common">
                            <h1 className="data">{item.value}</h1>
                            <h3 className="dataUnits">{item.unit}</h3>
                            <p className="description">{item.description}</p>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    )
}

export default FigureCards